import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import { wrapStorage } from "./wrapstorage";

declare const MODULES: [
  {
    id: string;
    url: string;
    route?: string[];
    filter?: string[];
    /**
     * header: top of page
     * sidebar: left panel
     * page: main page
     */
    position?: "header" | "sidebar" | "page";
  }
];

const buildTemplate = (modules) => {
  // const paths: string[] = window.location.pathname.split("/");
  const buildAppElement = (m) => {
    const rv = '<application name="' + m.id + '"></application>';
    // if (m.position === "default") {
    //   rv = "<route default>" + rv + "</route>";
    // } else if (m.route) {
    //   const path = ("/" + m.route.join("/")).replace(/\/\/+/, "/");
    //   rv = '<route path="' + path + '">' + rv + "</route>";
    // }
    return rv;
  };

  let header = modules.filter(
    (m) => (m.position || "").toLowerCase() === "header"
  );

  let sidebar = modules.filter(
    (m) => (m.position || "").toLowerCase() === "sidebar"
  );
  const page = modules.filter((m) => {
    const pos = (m.position || "").toLowerCase();
    return pos !== "sidebar" && pos !== "header";
  });

  let html = '<template id="single-spa-layout"><single-spa-router>';

  if (window.location.pathname === "/home/landing") {
    header = false;
    sidebar = false;
  }

  //Header

  if (header) {
    html += "<header>";
    header.forEach((el) => {
      html += buildAppElement(el);
    });

    html += "</header>";
  }

  //Sidebar

  html += "<main>";
  if (sidebar) {
    html += '<div id="sidenav">';

    sidebar.forEach((el) => {
      html += buildAppElement(el);
    });

    html += "</div>";
  }

  html += '<div id="page">';
  page.forEach((el) => (html += buildAppElement(el)));
  html += "</div></main>";

  html += "</single-spa-router></template>";

  const div = document.createElement("div");
  div.innerHTML = html;
  return div.firstChild as HTMLTemplateElement;
};

(function (modules, win) {
  const routes = constructRoutes(buildTemplate(modules));
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  const appData = {};

  applications.forEach((app) => {
    const key = app.name;

    const module = modules.find((m) => m.id === key);

    appData[key] = {
      evtElem: document.createElement("div"),
      listeners: {},
      published: {
        self: key,
        listMFE: () => applications.map((x) => x.name),

        // *** routing
        route: (module || { route: [] }).route || [],
        filter: (module || { filter: [] }).filter || [],
        getMFERoute: (name) => {
          const app = appData[name];
          if (!app || !app.published) {
            return null;
          }
          return app.published.route;
        },
        // ***********

        // *** event exchange
        broadcast: (evt, data?) => {
          Object.values(appData).forEach((ad) => {
            if (ad === appData[key]) {
              return;
            }
            if ((ad as any).evtElem) {
              (ad as any).evtElem.dispatchEvent(
                new CustomEvent(evt, { detail: { sender: key, data } })
              );
            }
          });
        },
        send: (target, evt, data?) => {
          const ad = appData[target];
          if (!!ad && !!ad.evtElem) {
            ad.evtElem.dispatchEvent(
              new CustomEvent(evt, { detail: { sender: key, data } })
            );
          }
        },
        off: (evt, listener) => {
          const ad = appData[key];
          if (!!ad && !!ad.evtElem) {
            if (!ad.listeners[listener]) {
              // console.error("Event not defined");
            } else {
              ad.evtElem.removeEventListener(evt, ad.listeners[listener]);
              delete ad.listeners[listener];
            }
          }
        },
        on: (evt, listener) => {
          const ad = appData[key];
          if (!!ad && !!ad.evtElem) {
            if (!listener) {
              console.error("Invalid event listener");
            } else {
              if (!ad.listeners[listener]) {
                ad.listeners[listener] = (e) => {
                  if (e instanceof CustomEvent) {
                    const sender = e.detail.sender;
                    const data = e.detail.data;
                    listener(data, sender);
                  }
                };
                ad.evtElem.addEventListener(evt, ad.listeners[listener]);
              } else {
                // console.error("Event already defined");
              }
            }
          }
        },
        // ******************

        // *** storage
        localStorage: wrapStorage(key, localStorage),
        sessionStorage: wrapStorage(key, sessionStorage),
        // ***********

        // *** language
        getLang: () => {
          if ((win as any).LANG && !!(win as any).LANG.get) {
            return (win as any).LANG.get();
          }
          return "it";
        },
        // ************
      },
    };

    app.customProps = { data: appData[key].published };
  });

  if ((win as any).LANG && (win as any).LANG.addListener) {
    (win as any).LANG.addListener((value) => {
      Object.values(appData).forEach((ad) => {
        if ((ad as any).evtElem) {
          (ad as any).evtElem.dispatchEvent(
            new CustomEvent("lang-change", {
              detail: { sender: null, data: value },
            })
          );
        }
      });
    });
  }

  applications.forEach((app) => {
    app.activeWhen = [
      (loc) => {
        const filters = app.customProps["data"]?.filter;
        if (!filters || filters.length === 0) {
          return true;
        }
        let rv = false;
        for (let i = 0; i < filters.length; i++) {
          if (filters[i].startsWith("!")) {
            if (loc.pathname.startsWith(filters[i].substring(1))) {
              rv = false;
              break;
            }
          } else {
            if (loc.pathname.startsWith(filters[i])) {
              rv = true;
            }
          }
        }
        return rv;
      },
    ];
    registerApplication(app);
  });
  layoutEngine.activate();
  start();

  return appData;
})(MODULES, window);
